import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Home,
  Tramites,
  TribunalDeDisciplina,
  Torneos,
  TorneoDetails,
  Autoridades,
  AdminLogin,
  AdminPanel,
  AdminTabPanel,
  AdminNewSponsor,
  AdminNewCategory,
  AdminNewPost,
  PostDisplay,
  AdminNewProcedure,
  AdminNewDisciplines,
  CategoryPosts,
} from "./pages";
import HeaderComponent from "./components/HeaderComponent";
import FooterComponent from "./components/FooterComponent";
export const API = process.env.REACT_APP_API_URL;
export const IMG_URL = process.env.REACT_APP_IMG_URL;

function App() {
  return (
    <Router>
      <HeaderComponent />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/tramites" element={<Tramites />} />
        <Route
          exact
          path="/tribunal-de-disciplina"
          element={<TribunalDeDisciplina />}
        />
        <Route exact path="/torneos" element={<Torneos />} />
        <Route
          exact
          path="/torneos/:fifaId/:competitionName"
          element={<TorneoDetails showPositions={true} />}
        />
        <Route
          exact
          path="/publicaciones/:permalink/:id"
          element={<PostDisplay />}
        />
        <Route
          exact
          path="/categorias/:permalink/:id"
          element={<CategoryPosts />}
        />
        <Route exact path="/autoridades" element={<Autoridades />} />
        <Route exact path="/admin" element={<AdminLogin />} />
        <Route exact path="/admin/panel/:tab?" element={<AdminTabPanel />} />
        <Route exact path="/admin/panel2" element={<AdminPanel />} />
        <Route
          exact
          path="/admin/panel/sponsors/new"
          element={<AdminNewSponsor />}
        />
        <Route
          exact
          path="/admin/panel/categories/new"
          element={<AdminNewCategory />}
        />
        <Route
          exact
          path="/admin/panel/categories/:categoryId/edit"
          element={<AdminNewCategory />}
        />
        <Route exact path="/admin/panel/posts/new" element={<AdminNewPost />} />
        <Route
          exact
          path="/admin/panel/posts/:postId/edit/"
          element={<AdminNewPost />}
        />
        <Route
          exact
          path="/admin/panel/sp/:sponsorId/edit/"
          element={<AdminNewSponsor />}
        />
        <Route
          exact
          path="/admin/panel/procedures/:procedureId/edit/"
          element={<AdminNewProcedure />}
        />
        <Route
          exact
          path="/admin/panel/procedures/new/"
          element={<AdminNewProcedure />}
        />
        <Route
          exact
          path="/admin/panel/disciplines/new/"
          element={<AdminNewDisciplines />}
        />
        <Route
          exact
          path="/admin/panel/disciplines/:disciplineId/edit/"
          element={<AdminNewDisciplines />}
        />
      </Routes>
      <FooterComponent />
    </Router>
  );
}

export default App;
